import React, { useEffect, useRef, useState } from "react";
import "./StatsSection.css";

import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import TimelineIcon from "@mui/icons-material/Timeline";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import BuildIcon from "@mui/icons-material/Build";
import PublicIcon from "@mui/icons-material/Public";

const stats = [
  {
    icon: <EmojiObjectsIcon />,
    value: 60,
    suffix: "+",
    label: "Projects Delivered",
    gradient: "linear-gradient(135deg, #6FD6D6, #1A6157)",
  },
  {
    icon: <TimelineIcon />,
    value: 4,
    suffix: "+",
    label: "Years of Experience",
    gradient: "linear-gradient(135deg, #1A6157, #0B2F2C)",
  },
  {
    icon: <PeopleAltIcon />,
    value: 61,
    label: "Satisfied Clients",
    gradient: "linear-gradient(135deg, #6FD6D6, #1A6157)",
  },
  {
    icon: <BuildIcon />,
    value: 20,
    suffix: "+",
    label: "Skilled Experts",
    gradient: "linear-gradient(135deg, #1A6157, #0B2F2C)",
  },
  {
    icon: <PublicIcon />,
    value: 25,
    label: "Countries Served",
    gradient: "linear-gradient(135deg, #6FD6D6, #0B2F2C)",
  },
];

const StatCard = ({ item, active }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!active) return;

    let start = 0;
    const duration = 1500;
    const step = item.value / (duration / 16);

    const timer = setInterval(() => {
      start += step;
      if (start >= item.value) {
        setCount(item.value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [active, item.value]);

  return (
    <div className="oglitz-stat-card">
      <div className="oglitz-stat-icon" style={{ background: item.gradient }}>
        {item.icon}
      </div>

      <h3>
        {count}
        {item.suffix || ""}
      </h3>
      <p>{item.label}</p>
    </div>
  );
};

const StatsSection = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="oglitz-stats-section" ref={sectionRef}>
      <div className="oglitz-stats-header">
        <h2>Our Growth in Numbers</h2>
        <p>Delivering measurable results through technology & trust</p>
      </div>

      <div className="oglitz-stats-grid">
        {stats.map((item, index) => (
          <StatCard key={index} item={item} active={visible} />
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
